// extracted by mini-css-extract-plugin
module.exports = {"scanQrContainer":"ScanQrCode_scanQrContainer__TW8E5","scanQrButton":"ScanQrCode_scanQrButton__x8BmD"};